import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { Facility } from '../model/facility';
import { ProductLine } from '../model/product-line';

@Injectable()
export class FilterProductlinesService {
    filterViewStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
    _facilityMasterList: BehaviorSubject<Array<Facility>> = new BehaviorSubject(null);
    _facilityCache: BehaviorSubject<Array<Facility>> = new BehaviorSubject(null);
    _productLineCache: BehaviorSubject<Array<ProductLine>> = new BehaviorSubject(null);
    _showOnlyFavorites: boolean;
    _noMatchesViewStatus: boolean = false;

    showFilter() {
        this.filterViewStatus.next(true);
    }

    hideFilter() {
        this.filterViewStatus.next(false);
    }

    checkForNoMatches() {
        this._facilityCache.subscribe(x => {
            let temp = [];
            x.forEach(a => {
                if (a.Selected === false) { temp.push(false) }
            });
            if (temp.length === x.length) {
                this._noMatchesViewStatus = true;
            } else {
                this._noMatchesViewStatus = false;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/filter-productlines.service.ts